import { motion } from "framer-motion";
import ocPreferredContractor from "@/assets/oc-preferred-contractor.jpg";
import BackgroundPattern from "@/components/BackgroundPattern";

const TrustedPartnersSection = () => (
  <section className="py-16 md:py-20 bg-section-light border-y relative" aria-label="Trusted partner credentials">
    <BackgroundPattern variant="grid" />
    <div className="container mx-auto max-w-5xl px-4 relative z-10">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="flex flex-col items-center text-center gap-6"
      >
        <p className="text-sm font-bold uppercase tracking-widest text-primary mb-0">
          Proudly Partnered With
        </p>
        <img
          src={ocPreferredContractor}
          alt="Owens Corning Preferred Contractor badge"
          className="h-20 md:h-24 object-contain"
          loading="lazy"
          width={200}
          height={96}
        />
        <h2 className="text-2xl md:text-3xl font-black text-foreground">
          Owens Corning Preferred Contractor
        </h2>
        <p className="text-muted-foreground max-w-lg mx-auto text-sm leading-relaxed">
          Only the top 1% of roofing contractors earn Preferred status — backed by enhanced warranties and premium materials you can trust.
        </p>
      </motion.div>
    </div>
  </section>
);

export default TrustedPartnersSection;
